type TutorialGuideProgressBarProps = {
  progressPercentage: number;
};

export function TutorialGuideProgressBar({
  progressPercentage = 0
}: TutorialGuideProgressBarProps) {
  const safeProgress = Math.max(0, Math.min(100, progressPercentage));

  return (
    <div className="w-full h-2 bg-gray-100 rounded-full">
      <div
        className="h-full bg-purple-500 rounded-full transition-all duration-300"
        style={{ width: `${safeProgress}%` }}
      />
    </div>
  );
}
